import DomCreate from "./utils/domCreate.js";

export default class StyledMultiSelect {
    options = {
        selector: '.styled-multi-select',
        groupControlSelector: '.control.control-group',
    };

    constructor(userOptions = {}) {
        for (const prop in userOptions) {
            if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
                this.options[prop] = userOptions[prop];
            }
        }

        this.initSelectors(document);
    }

    initSelectors(rootElement) {
        const selectElements = rootElement.querySelectorAll(this.options.selector)

        selectElements.forEach(selectElement => {
            this.initDom(selectElement);
            this.initInputs(selectElement);
        });
    }

    initDom(selectElement) {
        if (selectElement.hasOwnProperty('styledMultiSelectInitialized')) { return; }
        selectElement.styledMultiSelectInitialized = true;

        const controlGroupElement = selectElement.querySelector(this.options.groupControlSelector);
        if (!controlGroupElement) { return; }

        const placeholderElement = selectElement.querySelector('.placeholder');
        placeholderElement.classList.add('is-hidden');

        const dropdown_id = 'dropdown-menu-'+(Math.random().toString(36).substring(2, 15));

        const dropdownElement = DomCreate.create('div', ['dropdown']);
        dropdownElement.innerHTML = `
            <div class="dropdown-trigger">
                <button class="button" aria-haspopup="true" aria-controls="${dropdown_id}">
                    <span class="selected-content tag-group-container field is-grouped is-grouped-multiline"></span>
                    <span class="selected-placeholder"></span>
                    <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" id="${dropdown_id}" role="menu">
                <div class="dropdown-content">
                    <div class="dropdown-item search"><input type="text" placeholder="filtr"/><button class="delete is-small"></button></div>
                </div>
            </div>
        `;
        controlGroupElement.insertBefore(dropdownElement, controlGroupElement.firstChild);

        const newPlaceholderElement = selectElement.querySelector('.selected-placeholder');
        newPlaceholderElement.innerHTML = placeholderElement.innerHTML;

        const dropdownContentElement = dropdownElement.querySelector('.dropdown-content');
        const controlElements = selectElement.querySelectorAll('.control-group > .control');
        controlElements.forEach(controlElement => {
            const dropdownItemElement = DomCreate.create('div', ['dropdown-item']);
            dropdownItemElement.insertBefore(controlElement, null);
            dropdownContentElement.insertBefore(dropdownItemElement, null);
        });

        this.initSearch(selectElement, dropdownElement);
    }

    initSearch(selectElement, dropdownElement) {
        const optionSearchElement = selectElement.querySelector(".dropdown-item.search");
        const optionElements = selectElement.querySelectorAll(".dropdown-item:not(.search)");

        if (optionSearchElement) {
            optionSearchElement.addEventListener("click", (e) => {
                e.stopPropagation();
                e.preventDefault();
            });

            const searchInput = optionSearchElement.querySelector("input");

            dropdownElement.querySelector("button,a").addEventListener("click", (e) => {
                e.preventDefault();

                if (dropdownElement.classList.contains("is-active")) {
                    searchInput.focus();
                }
            });

            searchInput.addEventListener("input", (e) => {
                optionElements.forEach( (optionElement) => {
                    if (optionElement.textContent.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(searchInput.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))) {
                        optionElement.classList.remove("is-hidden");
                    }else{
                        optionElement.classList.add("is-hidden");
                    }
                });
            });

            const buttonDelete = optionSearchElement.querySelector("button.delete");

            buttonDelete.addEventListener("click", (e) => {
                searchInput.value = "";
                searchInput.focus();
                optionElements.forEach( (optionElement) => {
                    optionElement.classList.remove("is-hidden");
                });
            });
        }
    }

    initInputs(selectElement) {
        const tagGroupElement = selectElement.querySelector('.tag-group-container');

        const checkboxElements = selectElement.querySelectorAll('label.checkbox');
        checkboxElements.forEach(checkboxElement => {
            if (checkboxElement.hasOwnProperty('styledMultiSelectInitialized')) { return; }
            checkboxElement.styledMultiSelectInitialized = true;
            checkboxElement.addEventListener('click', (e) => e.stopPropagation());
            const onChangeInput = (checkbox) => {
                const inputElement = checkbox.querySelector('input[type="checkbox"]');
                const checkboxLabelElement = checkbox.querySelector('.checkbox-label');
                if (inputElement.checked) {
                    if (tagGroupElement.querySelector(`div[data-name="${inputElement.name}"]`)) {
                        return;
                    }
                    const tagElement = DomCreate.create('div', ['control']);
                    tagElement.dataset.name = inputElement.name;
                    const tagContainerElement = DomCreate.create('div', ['tags', 'has-addons']);
                    tagElement.insertBefore(tagContainerElement, null);
                    const tagBodyElement = DomCreate.create('div', ['tag', 'is-light']);
                    tagBodyElement.innerHTML = checkboxLabelElement.innerHTML;
                    tagContainerElement.insertBefore(tagBodyElement, null);
                    const tagCloseElement = DomCreate.create('a', ['tag', 'is-delete']);
                    tagContainerElement.insertBefore(tagCloseElement, null);
                    tagCloseElement.addEventListener('click', (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        inputElement.checked = false;
                        tagElement.remove();
                    });
                    tagGroupElement.insertBefore(tagElement, null);
                } else {
                    const tagsToRemove = tagGroupElement.querySelectorAll(`div[data-name="${inputElement.name}"]`);
                    tagsToRemove.forEach(tagToRemove => tagToRemove.remove());
                }
            };

            const inputElement = checkboxElement.querySelector('input[type="checkbox"]');
            inputElement.addEventListener('change', () => onChangeInput(checkboxElement));
            onChangeInput(checkboxElement);
        });
    }
}